import type { IconData } from '@stacksjs/iconify-core'

export const vimeo: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M19.129.849C18.646.323 17.946.042 17.05.016c-2.53-.083-4.319 1.277-5.317 4.04a.41.41 0 0 0 .083.42a.4.4 0 0 0 .405.118q.433-.12.847-.12c.369 0 .86.068 1.103.394c.188.25.213.626.076 1.116c-.115.413-.711 1.52-1.449 2.69c-.898 1.427-1.394 2.067-1.537 2.067c-.474 0-2.187-7.673-2.234-7.842C8.535 1.141 8.289.26 6.69.26C5.474.258 2.758 2.504.528 4.461l-.342.299a.54.54 0 0 0-.074.736l.415.54a.526.526 0 0 0 .727.109l.023-.017C2 5.611 2.68 5.121 3.195 5.094c.559-.027 1.044.855 1.622 2.955c1.102 4.078 2.775 8.94 4.493 8.94c1.794 0 3.935-1.538 6.703-5.176c2.505-3.294 3.846-5.905 3.933-7.806c.064-1.435-.21-2.498-.817-3.158\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default vimeo
